<template>
  <div class="photo-fullscreen">
    <v-dialog v-model="show" fullscreen class="ma-0 pa-0 black lighten-5">
      <div class="fill-height d-flex align-center black lighten-5">
        <v-img
          contain
          max-height="100%"
          :src="img"
          alt=""
          @click="show = false"
        />
      </div>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    img: {
      String,
    },
    value: Boolean,
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
};
</script>

<style scoped></style>
